import React,{useEffect,useState} from 'react';
import { googleLogout, useGoogleLogin, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../../actions/auth';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
const centerButtonStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh', // Adjust the height as needed for your layout
  background: '#ffffff78',
  borderRadius:'10px'
};

const containerFull={
  height:'100vh',
  background:'linear-gradient(90deg, rgba(238, 109, 152, 1) 15%, rgba(138, 94, 191, 1) 85%)'
}

const textStyles = {
  fontSize: '30px',
  fontWeight:'200',
  color: '#ffffff', // You can change the color
  marginBottom: '20px', // Add spacing between the text and the button
};
const textStyles2 = {
  fontSize: '30px',
  fontWeight:'200',
  color: '#ffffff', // You can change the color
  marginBottom: '40px', // Add spacing between the text and the button
};

const Auth = ({setUser,isAuthenticated}) => {
  const navigate= useNavigate();

  useEffect(()=>{
    if(localStorage.token){ setUser(localStorage.token);
    navigate('/insight');}
 
  },[]);
  const [ user, setUser_ ] = useState(null);
  if(isAuthenticated){
    navigate('/insight');
    }
  return (
    <div style={containerFull}>
      <div className="container" style={centerButtonStyle}>
      <p style={textStyles}>Placement Insights</p>
      <p style={textStyles2}>Login to verify using institute email id</p>

      <GoogleLogin
        onSuccess={credentialResponse => {
          console.log(credentialResponse);
          setUser_(credentialResponse.clientId);
          setUser(credentialResponse.clientId);
          localStorage.setItem('token',credentialResponse.clientId);
          if(isAuthenticated){
          navigate('/insight');
          }
        }}
        onError={() => {
          console.alert('Login Failed');
        }}
        useOneTap
      />
      
    </div>
    
    </div>
    
  );
};
Auth.propTypes={
  setUser:PropTypes.func.isRequired,
 
  
  isAuthenticated:PropTypes.bool
}
const mapStateToProps=state=>({
  isAuthenticated:state.auth.isAuthenticated

})
export default connect(mapStateToProps,{setUser}) (Auth);

 
